module.exports = __webpack_public_path__ + "img/earth.071bd206.png";